<template>
  <div>
    <Head title="註冊" />

    <Dialog :modal="true" :visible.sync="showModal">
      <template #header>
          <p class="text-2xl" v-if="modalType == 'term'">網站會員使用條款</p>
          <p class="text-2xl" v-if="modalType == 'privacy'">網站隱私權條款</p>
          <p class="text-2xl" v-if="modalType == 'return'">網站退換貨及退費規則</p>
        </template>

      <template v-if="modalType == 'term'">        
        <p>
          為保障您的權益，請於註冊使用FoodyHome吃貨家網站服務前，詳細閱覽以下規定。一旦您註冊為台灣FoodyHome吃貨家網站會員或使用FoodyHome吃貨家網站所提供之任何服務，即表示同意並遵守以下所有規定。
        </p>
        <br />
        <p>
          1.您於FoodyHome吃貨家網站註冊成為會員後，會員資格範圍僅限於台灣FoodyHome吃貨家網站，當您使用所提供之各項網路服務時，即表示同意並遵守該等網站之會員規範及當地之法律規定。若您為未滿十八歲，應於您的家長（或監護人）閱讀、瞭解並同意本規範之所有內容，方得使用台灣FoodyHome吃貨家網站。當您使用本網站之各項服務時，即表示您的家長（或監護人）已閱讀、瞭解並同意接受本規範之所有內容。
        </p>
        <br />
        <p>
          2.
          FoodyHome吃貨家網站係透過網際網路提供您各項網路資訊服務。您必須自行配備上網所需的各項電腦設備，以及負擔接上網際網路的費用及電話費用。基於FoodyHome吃貨家網站所提供的各項服務，您同意於會員註冊時提供詳實的個人資料，並隨時更新過時或已變更之個人資料。如果您提供的個人資料不實，FoodyHome吃貨家網站得隨時終止您會員資格及使用各項服務之資格。
        </p>
        <br />
        <p>
          3.使用者依本網站之指示完成註冊後，除有特別規定者外，將可享受FoodyHome吃貨家網站完整服務。於註冊前，請先確認您已符合法律所規定之年齡限制，並同意遵守下列事項
          :
        </p>
        <ul>
          <li>
            <p>(1)於帳號申請表中提供正確、現有且完整的個人資訊。</p>
          </li>
          <li>
            <p>
              (2)隨時更新個人資料以確保每項資料均能維持正確、現有且完整之要求，若使用者提供錯誤、過時或缺漏之個人資料，或FoodyHome吃貨家認為使用者所提供之資料為錯誤、過時或缺漏，FoodyHome吃貨家擁有暫停或終止使用者對FoodyHome吃貨家下轄所有服務之使用權。
            </p>
          </li>
        </ul>
        <br />
        <p>4.會員規範與服務的異動 :</p>
        <ul>
          <li>
            <p>
              (1)FoodyHome吃貨家網站有權隨時修改本規範，並於FoodyHome吃貨家網站首頁及會員專區公告修改之事實與內容。如果您不同意修改的內容，請勿繼續使用FoodyHome吃貨家網站服務。一旦於會員規範修改後繼續使用各項網路服務，則表示您同意並接受本規範之任何修改。
            </p>
          </li>
          <li>
            <p>
              (2)
              FoodyHome吃貨家網站有權隨時停止或更改各項服務內容，並無需事先通知您，對於停止或更改服務所可能導致之困擾、不便、損害，FoodyHome吃貨家網站不負任何責任。
            </p>
          </li>
        </ul>
        <br />
        <p>5.會員隱私權保護 :</p>
        <p>
          尊重每位會員的個人隱私權是FoodyHome吃貨家網站基本政策。因此，除法律規定或司法等相關主管機關因維持公共利益之要求外，FoodyHome吃貨家網站在未獲得您的授權時，將不會公開您的姓名、地址、電子郵件信箱，及其他依法受保護之個人資訊。<br />FoodyHome吃貨家網站所提供之各項會員服務，您同意在法律許可範圍內，允許其關係企業或合作夥伴，在必要之範圍內，得使用您的個人資訊，以提供您優質的會員服務內容。<br />您同意FoodyHome吃貨家網站得就您的個人資料作成會員統計、分析。如該統計資料，不涉及揭露任何會員的個人身份，您同意並允許FoodyHome吃貨家網站為任何合法之使用。<br />您同意FoodyHome吃貨家網站，於下列情形發生時，得依法公開您的個人資訊：
        </p>
        <br />
        <ul>
          <li>
            <p>(1)因應法律及相關主管機關要求；</p>
          </li>
          <li>
            <p>(2)為保障FoodyHome吃貨家網站之財產及權益；</p>
          </li>
          <li>
            <p>(3)在緊急情況下為保障FoodyHome吃貨家網站會員或公共安全時。</p>
          </li>
        </ul>
        <br />
        <p>6. FoodyHome吃貨家網站賠償責任限制及服務終止 :</p>
        <ul>
          <li>
            <p>
              (1)對於您使用本網之各項服務，或因無法使用各項服務所致生任何直接、間接、衍生、或特別損害，FoodyHome吃貨家網站不負任何賠償責任。
            </p>
          </li>
          <li>
            <p>
              (2)
              FoodyHome吃貨家網站有權單方終止您的會員資格。您若欲終止個人之會員資格，須以書面通知。FoodyHome吃貨家網站有權隨時結束各項服務，您同意並充分了解FoodyHome吃貨家網站並未承諾維持任何一項服務不停止或不中斷。
            </p>
          </li>
        </ul>
        <br />
        <p>7.會員義務與責任 :</p>
        <ul>
          <li>
            <p>
              (1)一旦註冊完成後，您將取得一個會員帳號及密碼，並自行對此帳號及密碼之安全負完全責任。您同意不會將會員帳號轉讓或出借他人使用。若發現您的帳號遭人非法使用或有任何異常破壞使用安全之情形時，應立即通知台灣FoodyHome吃貨家網站處理。
            </p>
          </li>
          <li>
            <p>
              (2)會員對於自行公布或透過FoodyHome吃貨家網站所公開、傳輸的一切內容負完全之責任。
            </p>
          </li>
          <li>
            <p>(3)會員應遵守中華民國相關法律及國際網際網路相關規定與慣例。</p>
          </li>
          <li>
            <p>
              (4)會員應同意並保證不公布或傳送任何毀謗、不實、威脅、不雅、猥褻、不法、或侵害他人智慧財產權的資訊於FoodyHome吃貨家網站上，一經發現或檢舉，FoodyHome吃貨家網站有終止會員服務之權利。
            </p>
          </li>
          <li>
            <p>
              (5)
              FoodyHome吃貨家網站不鼓勵會員從事商品或服務等商業買賣行為，會員於FoodyHome吃貨家網站所涉及之商業買賣行為，FoodyHome吃貨家網站本於未知之立場，不負完全擔保責任。
            </p>
          </li>
          <li>
            <p>
              (6)對於因違反相關法令或本規範所致生之一切實質損害、名譽毀損等，您同意對FoodyHome吃貨家網站、其母公司、子公司、關係企業、受僱人及相關人員，負完全之損害賠償責任。
            </p>
          </li>
          <li>
            <p>
              (7)
              FoodyHome吃貨家網站就會員行為是否符合本規範，有最終決定權。一經發現或檢舉違反本規範或任何法令，FoodyHome吃貨家網站得立即停止會員使用本網各項服務。
            </p>
          </li>
        </ul>
        <br />
        <p>
          8.
          FoodyHome吃貨家網站有權將FoodyHome吃貨家網站軟硬體、商業模式、以及用戶資料（包括會員錄製之聲音與所產生之數位聲紋檔案）轉讓予併購者，而不用事先通知會員。或經會員事先同意，一經轉讓後，FoodyHome吃貨家網站與會員間原有之權利義務關係立即解消。
        </p>
        <br />
        <p>
          9.您了解FoodyHome吃貨家網站上刊登有商業廣告及各種非本站之商品之促銷資訊。該等內容均係由廣告商或商品服務提供人所為，FoodyHome吃貨家網站僅係提供刊登內容之媒介。您透過本網所提供之商品、服務廣告資訊，所購買的任何商品、服務，其過程中之商業交易關係均存在於您與商品服務提供者之間，與FoodyHome吃貨家網站無關。
        </p>
        <br />
        <p>10.其他一般規定 :</p>
        <ul>
          <li>
            <p>
              (1)本規範以中華民國相關法律（不含涉外民事法律適用法或其他類似法規）為準據法。
            </p>
          </li>
          <li>
            <p>
              (2)就本規範涉及的一切爭訟，您同意以台灣橋頭地方法院為第一審管轄法院。
            </p>
          </li>
          <li>
            <p>(3)本規範若任何一部份無效，不影響其他部份之效力。</p>
          </li>
        </ul>
        <br />
        <p>11.修改本使用條款的權利 :</p>
        <p>
          本網站保留隨時修改本網站會員使用條款的權利，修改後的本網站會員使用條款將公佈在本網站上，不另外個別通知使用者。
        </p>
        <p>
          若有任何爭議性決定，以本網站公佈的結果為準。會員及其他三人所提供之證據或建議僅供本網站參考，不對本網站具任何約束力。
        </p>
      </template>
      <template v-if="modalType == 'privacy'">        
        <p>
            FoodyHome吃貨家網站係由友力食業有限公司(統一編號 : 90894058)所經營。這份隱私權的保障聲明，為因應社會環境及法令規定的變遷與科技的進步，友力食業有限公司為保護客戶隱私，有權修改這份公告聲明，並儘速更新與告知客戶。友力食業有限公司非常尊重客戶的隱私權，對於客戶資料的蒐集、處理及利用均遵守中華民國政府之「個人資料保護法」及相關法令規範，您可以參照以下隱私權政策，了解我們的具體措施；歐盟會員身份不適用本公司目前所有服務，若您未告知是否具備歐盟會員國國民身份，本公司將認定您不具備歐盟國民身份，並會為您提供服務。
        </p>
        <br>
        <p>
            1.本隱私權政策適用之範圍 : 
        </p>
        <p>
            本隱私權政策及其所包含之告知事項，僅適用於友力食業有限公司所擁有及經營的網站。本網站內可能包含許多連結、或其他合作夥伴所提供的服務，關於該等連結網站或合作夥伴網站的隱私權聲明及與個人資料保護有關之告知事項，請參閱各該連結網站或合作夥伴網站。
        </p>
        <br>
        <p>
            2.客戶資料蒐集、處理及利用之合法依據 : 
        </p>
        <ul>
            <li>
                <p>
                    (1)我們擁有客戶的個人資料，是由FoodyHome吃貨家網站及其相應行動應用程式註冊會員或消費之客戶所提供。
                </p>
            </li>
            <li>
                <p>
                    (2)由我們在其他行銷或異業結盟活動中合法取得(包括但不限於自業務合作廠商處取得)，本公司針對前段資料，將在處理及利用前，向您說明資料來源及各必要告知事項。
                </p>
            </li>
            <li>
                <p>
                    (3)本公司擁有您之個人資料均依照個人資料保護法之規定進行蒐集、處理及利用 : <br>
                    <div class="ml-6">
                        <p>
                            ①您加入本公司會員時，透過您同意提供之資料。<br>
                            ②與您有契約或類似契約之關係，如您進行商品訂購、本公司進行商品配送等。<br>
                            ③具法律明文規定，要求本公司進行蒐集、處理或利用。<br>
                            ④您自行公開或已合法公開之資料，惟本公司不主動進行左列資料之蒐集、處理或利用。<br>
                            ⑤為增進公共利益，惟本公司僅於維護資訊安全、防止詐欺等合法利益下進行必要及有限之資料處理。<br>
                            ⑥對您的權益無侵害，惟本公司僅於核實本公司資料蒐集目的下，進行必要及合理之處置。<br>
                        </p>
                    </div>

                </p>
            </li>
            <li>
                <p>
                    (4)本公司不處理個人資料保護法第6條所指之各項資料。
                </p>
            </li>
        </ul>
        <br>
        <p>
            3.客戶資料蒐集種類 : 
        </p>
        <ul>
            <li>
                <p>
                    (1)我們會依據FoodyHome吃貨家網站提供之服務，請客戶提供必要之作業資料，若您不提供相關資料，或提供之資料不正確，將影響本公司之服務品質 :<br>
                    <div class="ml-6">
                        <p>
                            ①FoodyHome吃貨家之會員或客戶，我們會請您提供基本資料 : 包含您提供之姓名、性別、身分證統一編號、出生年月日、聯絡電話、聯絡地址、電子郵件信箱及其他您主動提供之資料。<br>
                            ②當您指定商品配送服務時，我們會請您提供配送資料 : 包含收件人之姓名、聯絡電話、聯絡地址及其他必要配送聯絡資料。<br>
                            ③當您有實際消費行為時，我們會留存您的帳務資料。但若您選擇使用應用程式內含的Apple Pay、Google Pay或其他第三方的付款方式，相關資訊將會依據該第三方服務供應商的隱私權條款進行保護與管理。<br>
                            ④我們基於提供市場分析、贈獎活動、會員及客戶權益通知等相關服務，將會為必要作業將請您提供其他資料。<br>
                        </p>
                    </div>

                </p>
            </li>
            <li>
                <p>
                    (2)依據法務部頒布之「個人資料保護法之特定目的及個人資料之類別」，本公司蒐集、處理、利用及保有您個人資料之種類列示如下 : <br>
                    <div class="ml-6">
                        <p>
                            Ｃ○○一 辨識個人者。(例如：姓名、職稱、住址、工作地址、以前地址、住家電話號碼、行動電話、網路平臺申請之帳號、會員編號、通訊及戶籍地址、電子郵遞地址及其他任何可辨識資料本人者等。)<br>
                            Ｃ○○二 辨識財務者。(例如：金融機構帳戶之號碼與姓名、信用卡或簽帳卡之號碼、保險單號碼、個人之其他號碼或帳戶等。)<br>
                            Ｃ○○三 政府資料中之辨識者。(例如：身分證統一編號、護照號碼等。)<br>
                            Ｃ○一一 個人描述。(例如：年齡、性別、出生年月日、出生地、國籍、聲音等。)<br>
                            Ｃ○二一 家庭情形。(例如：結婚有無、配偶或同居人之姓名、前配偶或同居人之姓名、結婚之日期、子女之人數等。)<br>
                            Ｃ○二三 家庭其他成員之細節。(例如：子女、受扶養人、家庭其他成員或親屬、父母等。)<br>
                            Ｃ○三一 住家及設施。(如：住所地址)<br>
                            Ｃ○三三 移民情形。(例如：護照)<br>
                            Ｃ○三四 旅行及其他遷徙細節。(例如：旅行細節)<br>
                            Ｃ○三六 生活格調。(例如：使用消費品之種類及服務之細節、個人或家庭之消費模式等。)<br>
                            Ｃ○三八 職業。(例如：學校校長、民意代表或其他各種職業等。)<br>
                            Ｃ○八一 收入、所得、資產與投資。<br>
                            Ｃ○九三 財務交易。(例如：收付金額、信用額度、保證人、支付方式、往來紀錄、保證金或其他擔保等。)<br>
                            Ｃ一○二 約定或契約。(例如：關於交易、商業、法律或其他契約、代理等。)<br>
                            Ｃ一三二 未分類之資料。(例如：無法歸類之信件、檔案、報告或電子郵件等。)
                        </p>
                    </div>

                </p>
            </li>
        </ul>
        <br>
        <p>
            4.客戶資料蒐集目的 : 
        </p>
        <ul>
            <li>
                <p>
                    (1)我們僅會在提供商品銷售、金融交易授權、物流配送、廣告行銷、市場分析、贈獎活動、會員權益通知、或其他附隨以上各樣服務及FoodyHome吃貨家未來所有可能衍生之及相關服務時，為作業之必要運用您的個人資料：<br>
                    <div class="ml-6">
                        <p>
                            ①物流寄送 : 我們會於提供客戶商品銷售、物流配送等履行訂單之服務，提供配送資料予合作廠商及物流商。<br>
                            ②金融交易授權 : 您所提供之基本資料、帳務資料及其他必要資料，將於金融交易過程(包含信用卡授權及照會)中，提供予金融機構以完成金融交易及相關業務。<br>
                            ③廣告行銷 : 為提供您更多優質商品、活動資訊及行銷新服務等。<br>
                            ④市場分析 : 依據您瀏覽廣告之內容、消費之紀錄及所提供之資料，本公司會進行市場分析，包含透過第三方使用cookie或類似技術，以開發及提供日後更優質之客戶服務。<br>
                            ※cookie是網站伺服器用來和使用者瀏覽器進行溝通的一種技術，它可能在使用者的電腦中儲存某些資訊。<br>
                            使用者可以經由瀏覽器的設定，取消或限制此項功能。<br>
                            ⑤其他業務附隨事項：依據以上所述服務目的、贈獎活動、會員相關權益通知，及您在使用FoodyHome吃貨家其他服務，有同意之前提下，於必要範圍內進行相關運用。 
                        </p>
                    </div>
                </p>
            </li>
            <li>
                <p>
                    (2)依據法務部頒布之「個人資料保護法之特定目的及個人資料之類別」，本公司蒐集、處理、利用及保有您個人資料之特定目的列示如下 :<br>
                    <div class="ml-6">
                        <p>
                            040行銷<br>
                            063非公務機關依法定義務所進行個人資料之蒐集處理及利用<br>
                            067信用卡、現金卡、轉帳卡或電子票證業務<br>
                            069契約、類似契約或其他法律關係事務<br>
                            090消費者、客戶管理與服務<br>
                            091消費者保護<br>
                            098商業與技術資訊<br>
                            107採購與供應管理<br>
                            111票券業務<br>
                            118智慧財產權、光碟管理及其他相關行政<br>
                            125傳播行政與管理<br>
                            127募款 (包含公益勸募)<br>
                            129會計與相關服務<br>
                            132經營傳播業務<br>
                            136資(通)訊與資料庫管理<br>
                            148網路購物及其他電子商務服務<br>
                            152廣告或商業行為管理<br>
                            157調查、統計與研究分析<br>
                            181其他經營合於營業登記項目或組織章程所定之業務 
                        </p>
                    </div>
                </p>
            </li>
        </ul>
        <br>
        <p>
            5.除下列情形外，我們僅會基於您授權的範圍，於您會員存續期間及服務所能到達地區內，依照前述服務目的範圍為作業之必要運用客戶資料 : 
        </p>
        <ul>
            <li>
                <p>
                    (1)法律明文規定。
                </p>
            </li>
            <li>
                <p>
                    (2)為增進公共利益所必要。
                </p>
            </li>
            <li>
                <p>
                    (3)為免除當事人之生命、身體、自由或財產上之危險。
                </p>
            </li>
            <li>
                <p>
                    (4)為防止他人權益之重大危害。
                </p>
            </li>
            <li>
                <p>
                    (5)經當事人同意。
                </p>
            </li>
            <li>
                <p>
                    (6)有利於當事人權益。
                </p>
            </li>
        </ul>
        <br>
        <p>
            6.客戶資料移轉、揭露對象及方式 : 
        </p>
        <ul>
            <li>
                <p>
                    (1)您的個人資料，本公司為主要接收者，我們僅會在充分取得您同意的前提之下，將個人資料交由本公司及我們所委任處理營業相關事務之第三人(例如：金融機構、合作廠商、物流商及業務往來之關係企業等服務提供者)運用，依照前述服務目的範圍為作業之必要運用或揭露客戶個人資料。除非另有法令規範，或另行取得您的同意，否則我們不會向前述以外之第三人揭露您的個人資料，且除與您的權利有重大影響、保護公共利益，或於取得您的同意為前提之下進行行銷，否則本公司不會主動聯繫您。
                </p>
            </li>
            <li>
                <p>
                    (2)我們提供資料予其他第三人的情形，除經過客戶本人同意，尙可能有以下情形 :<br>
                    <div class="ml-6">
                        <p>
                            ①於上開特定目的範圍作業利用之必要。<br>
                            ②合於個人資料保護法第20條但書規定為特定目的外之利用。<br>
                            ③基於法律之規定或受司法機關與其他有權機關基於法定程序之要求。<br>
                            ④在緊急情況下為維護其他會員或第三人之合法權益。<br>
                            ⑤為維護會員服務系統的正常運作。<br>
                            ⑥會員透過本服務購物、兌換贈品、參加抽獎活動等因而產生的金/物流之必要資訊。<br>
                        </p>
                    </div>
                </p>
            </li>
            <li>
                <p>
                    (3)本公司或與其合作行銷之第三方業務合作公司(下稱第三方業務合作公司)會在您同意之情形下，始得利用您的個人資料於行銷活動資訊、商品訊息或新服務等相關行銷。如您拒絕接受行銷服務或嗣後欲拒絕時，均可隨時通知我們，本公司或第三方業務合作公司將立即停止利用您的個人資料行銷。
                </p>
            </li>
        </ul>
        <br>
        <p>
            7.客戶資料保存期間及儲存保管安全 :
        </p>
        <ul>
            <li>
                <p>
                    (1)您提供之個人資料，本公司將於提供您各項會員服務為目的之存續期間持續保存，直至您刪除帳戶，或當您行使相關個人權利時為止。
                </p>
            </li>
            <li>
                <p>
                    (2)本網站主機均設有防火牆、防毒系統等相關的各項資訊安全設備及必要的安全防護措施，加以保護網站及您的個人資料。
                </p>
            </li>
            <li>
                <p>
                    (3)關於您提供的個人資料，我們將就資訊系統及公司作業規則制定嚴格規範，任何人均須在我們明定的授權規範下才能處理及利用必要之資料。
                </p>
            </li>
        </ul>
        <br>
        <p>
            8.客戶資料權利行使 : 
        </p>
        <ul>
            <li>
                <p>
                    (1)依個人資料保護法第 3 條規定，除非有其他法令限制，您就您所提供之個人資料享有查詢或請求閱覽、請求製給複製本、請求補充或更正、請求停止蒐集處理或利用(包含撤回同意、反對本公司繼續處理您的資料)、請求刪除的權利。
                </p>
            </li>
            <li>
                <p>
                    (2)如果您欲行使上述權利或是有其他諮詢、投訴事項，可以寄E-MAIL至spport@foody-home.com完成相關操作，或逕由官方客服LINE聯絡客服提出意見，我們將盡快回覆您的問題。
                </p>
            </li>
            <li>
                <p>
                    (3)本公司受理您行使各項個人權利，若為查詢或請求閱覽、請求製給複製本，本公司將於提出請求之15日內回覆，必要時得再延長15日，本公司將以電話通知您延長原因；若為請求補充或更正、請求停止蒐集處理或利用、請求刪除，本公司將於提出請求之30日內回覆，必要時得再延長30日，本公司將以電話通知您延長原因。
                </p>
            </li>
        </ul>
        <br>
        <p>
            9.在此提醒您，客戶如未提供完整的個人資料，可能無法成為我們的會員，或是享受各項相應的會員優惠服務或最新資訊 ; 如客戶提供之資料錯誤，本公司亦不受此聲明之約束。
        </p>
        <br>
        <p>
            10.關於此份隱私權聲明，我們得隨時因應社會環境及法令規定的變遷與科技的進步進行修改，並將修改內容以電子郵件、電話、型錄、通信網路、網路公告或其他適當方式通知客戶；當您使用或繼續使用FoodyHome吃貨家所提供之任一服務時，且於確認隱私及會員相關條款後，表示您已閱讀、瞭解並同意接受本服務條款之所有內容。
        </p>
        <br>
        <p>
            11.修改本使用條款的權利 :
        </p>
        <p>
            本網站保留隨時修改本網站隱私權條款的權利，修改後的本網站隱私權條款將公佈在本網站上，不另外個別通知使用者。
        </p>
        <p>
            若有任何爭議性決定，以本網站公佈的結果為準。會員及其他三人所提供之證據或建議僅供本網站參考，不對本網站具任何約束力。
        </p>
    
      </template>
      <template v-if="modalType == 'return'"> 
          <p>
            1.依據「通訊交易解除權合理例外情事適用準則」第二條第一項：「易於腐敗、保存期限較短或解約時即將逾期」之商品，屬於消費者保護法第十九條第一項但書所稱合理例外情事。自105年1月1日起，生鮮食品不適於消費者保護法第十九條，並不享有七天鑑賞期。因冷凍、生鮮食品均屬消耗性商品，商品屬性特殊或有保存期限等問題，除商品本身瑕疵或運送過程而造成的損毀，才可接受您的退貨申請。非上述情事恕無法為您辦理退換貨，故下單前請務必愼重考慮。一經拆封、食用、失溫及保存不良等情形而導致商品變質，則無法接受您的退換貨申請，敬請見諒!!
          </p>
          <br />
          <p>
            2.本網站商品於出貨前皆會詳細檢查，確認其完整及無瑕疵後方寄出。若於運送過程中有毀損或失溫導致變質，請於收到商品時立即拍照或綠影，並於二小時內與我們聯繫（以簽收時間起算之）。若發生上述情形，待本店收到您的商品照片或影片，確認無誤後，即會協助進行後續相關作業。期間請確保商品本身、外包裝、以及所付單據的完整性，並請妥善存放商品於合適的保存溫度及條件，否則恕不接受退貨申請。若購買者委託第三人（鄰居、友人、管理員）代收，辦理退換貨條件亦同;
            本店不負簽收後商品保管及保存責任。
          </p>
          <br />
          <p>
            3.FoodyHome吃貨家基於重視客戶需求與服務品質，若商品眞有不符合您的期許，有退/換貨需求時，請保持商品本體、贈品、內外包裝、發票及所有附隨文件或資料的完整性，切勿有任何缺漏或毀損，並請妥善存放商品於合適的保存溫度及條件，否則恕不接受退換貨申請。退貨時本公司並將收取每趟250元運費之損失，共兩趟(出貨與收回，為500元)，待人員確認商品無誤且無短少破損，將進行退換貨程序。
          </p>
          <br />
          <p>4.無法退換貨說明</p>
          <ul>
            <li>
              <p>(1)因個人口感或料理方式的問題。</p>
            </li>
            <li>
              <p>
                (2)未附上原包裝盒(含外包裝或包裝不完整)及破損無法辨識之商品及發票。
              </p>
            </li>
            <li>
              <p>(3)因特別情況已註明無法退換貨之商品。</p>
            </li>
            <li>
              <p>
                (4)辦理退貨/換貨時，請事先聯繫客服，若消費者未通知，而自行將商品寄回者，本公司將不予受理退/換貨，並立即將商品寄回，且期間所產生的運費消費者需自行負擔。
              </p>
            </li>
          </ul>
          <br />
          <p>
            5.因食品衛生考量，產品一經拆封將影響您的後續退換貨及其他權益。外包裝及其內容物、贈品等均屬於商品的一部分，申請退貨者，本公司將依照商品於退貨時之不完整程度(遺失、毀損或缺件等)，就商品價金之範圍內扣除回復原狀費用後，返還剩餘網站購物金及價金予消費者(順序為先網站購物金後價金)，並將該筆訂單獲得之C.V.扣除。建議您使用原外包裝（紙箱或包裝袋）將商品包好，切勿在原廠包裝或外盒上為任何書寫，以免造成損毀，影響您的退換貨權益。
          </p>
          <br />
          <p>
            6.若因退貨造成訂單純商品金額未達購物免運費標準，仍將於退貨退款時扣除原訂單之250元物流處理費，免運費標準請依本網站之各項商品免運費條件或行銷公告為依據。
          </p>
          <br />
          <p>
            7.
            如因各種因素退換貨次數過多，FoodyHome吃貨家將視情況決定是否對您的訂單暫停出貨，煩請見諒。
          </p>
          <br />
          <p>
            8.
            退換貨時請連同發票並保持包裝及商品整體完整，本公司將會通知宅配公司到貴退貨地點取貨或與您協調其他方式，將退換貨商品送回本公司客戶服務部門，經過檢查無缺之後，我們會儘速與您聯絡退費換貨事宜。
          </p>
          <br />
          <p>9.退費機制 :</p>
          <ul>
            <li>
              <p>
                (1)本公司收到退貨商品後將拆封確認商品、發票等相關附件是否完整，經審核後會由客服人員為您辦理退貨暨退款事宜。
              </p>
            </li>
            <li>
              <p>
                (2)網站購物金無法作退換貨物流處理費及商品回復原狀處理費之抵扣。除訂單支付價金額不足時，本公司同意以網站購物金替代價金扣抵。
              </p>
            </li>
            <li>
              <p>
                (3)扣除退換貨物流處理費及商品回復原狀處理費後之退費，將優先退回網站購物金至該筆訂單帳號之購物金帳號，並沿用該筆網站購物金之原使用期限。
              </p>
            </li>
            <li>
              <p>
                (4)如退費金額超過訂單中使用之網站購物金時，退款的金額，將於收到退貨商品後七至十五天匯至您指定的銀行帳戶。如您是使用信用卡支付，將於收到退貨商品後七至十五天，為您完成刷退手續，請您留意下一期帳單。
              </p>
            </li>
          </ul>
          <br />
          <p>10.修改本使用條款的權利 ：</p>
          <p>
            本網站保留隨時修改本網站退／換貨政策的權利，修改後的本網站退／換貨政策將公佈在本網站上，不另外個別通知使用者。
          </p>

          <p>
            若有任何爭議性決定，以本網站公佈的結果為準。會員及其他三人所提供之證據或建議僅供本網站參考，不對本網站具任何約束力。
          </p>
          <br />
          <p>
            11.若有相關問題，歡迎使用下列聯絡方式與我們聯繫，會有專人為您服務。
          </p>
          <ul>
            <li>
              <p>(1)入吃貨家官方客服LINE帳號 : @foodyhome</p>
            </li>
            <li>
              <p>(2)寄E-MAIL至 : support@foody-home.com</p>
            </li>
          </ul>
      </template>

      <div v-if="modalType == 'term' || modalType == 'privacy' || modalType == 'return'" class="my-10 text-center">
        <Button icon="pi pi-check" label="我要繼續註冊並且同意上述條款。" class="p-button-success" @click="acceptPolicy" />
      </div>
    </Dialog>

    <div
      class="
        flex flex-col
        sm:justify-center
        items-center
        max-w-md
        mx-auto
        my-16
        card
      "
    >
      <div class="flex flex-row w-full justify-between">
        <div
          class="tab"
          :class="{
            'border-r border-b text-fh-gray-light': route().current('login'),
          }"
        >
          <Link :href="route('register')">註冊會員</Link>
        </div>
        <div
          class="tab"
          :class="{
            'border-l border-b text-fh-gray-light': route().current('register'),
          }"
        >
          <Link :href="route('login')">會員登入</Link>
        </div>
      </div>
      <div class="w-full">
        <div class="mx-auto">
          <div class="register_form_element">
            <div class="label">
              <label for="name">真實姓名</label>
            </div>
            <div class="input">
              <InputText
                id="name"
                type="text"
                v-model="form.name"
                :class="{ 'p-invalid': $page.props.errors.name }"
              />
              <div v-if="$page.props.errors.name" class="error_information">
                <i class="pi pi-arrow-up" /> {{ $page.props.errors.name }}
              </div>
            </div>
          </div>
          <div class="register_form_element">
            <div class="label">
              <label for="mobile">行動電話</label>
            </div>
            <div class="input">
              <InputText
                id="mobile"
                v-model="form.mobile"
                :class="{ 'p-invalid': $page.props.errors.mobile }"
                @input="checkSmsVerify"
              />
              <div class="mt-1">
                <InputText
                  class="w-20"
                  v-model="sms.verify"
                  @input="smsVerify"
                  :disabled="sms.is_verifying || sms.is_verifyed"
                  placeholder="驗證碼"
                  :class="{
                    'p-invalid': $page.props.errors.mobile || sms.is_failed,
                  }"
                />
                <Button
                  v-if="!sms.is_verifyed"
                  @click="smsSend"
                  :disabled="
                    sms.counting || sms.is_verifying || form.mobile.length < 10
                  "
                >
                  <template v-if="!sms.counting">發送驗證瑪</template>
                  <template v-else>{{ timer }}秒後可重試</template>
                </Button>
                <i
                  v-else
                  class="pi pi-check ml-2"
                  style="font-size: 1.2rem"
                ></i>
              </div>
              <div v-if="$page.props.errors.mobile" class="error_information">
                <i class="pi pi-arrow-up" /> {{ $page.props.errors.mobile }}
              </div>
            </div>
          </div>
          <div class="register_form_element">
            <div class="label">
              <label for="email">電子郵件</label>
            </div>
            <div class="input">
              <InputText
                id="email"
                type="text"
                v-model="form.email"
                :class="{ 'p-invalid': $page.props.errors.email }"
              />
              <div v-if="$page.props.errors.email" class="error_information">
                <i class="pi pi-arrow-up" /> {{ $page.props.errors.email }}
              </div>
            </div>
          </div>
          <div class="register_form_element">
            <div class="label">
              <label for="password">密碼</label>
            </div>
            <div class="input">
              <Password
                id="password"
                v-model="form.password"
                toggleMask
                promptLabel="請輸入您的密碼"
                weakLabel="弱"
                mediumLabel="一般"
                strongLabel="強"
                :class="{ 'p-invalid': $page.props.errors.password }"
              />
              <div v-if="$page.props.errors.password" class="error_information">
                <i class="pi pi-arrow-up" /> {{ $page.props.errors.password }}
              </div>
            </div>
          </div>
          <div class="register_form_element">
            <div class="label">
              <label for="password_confirmation">確認密碼</label>
            </div>
            <div class="input">
              <Password
                id="password_confirmation"
                v-model="form.password_confirmation"
                :feedback="false"
                promptLabel="再次輸入您的密碼"
                :class="{ 'p-invalid': $page.props.errors.password }"
              />
            </div>
          </div>
          <div class="register_form_element">
            <div class="label">
              <label for="referral_code">
                推薦碼<br />
                <span class="text-xs">（如無請留空）</span>
              </label>
            </div>
            <div class="input">
              <InputText
                id="referral_code"
                type="text"
                v-model="form.referral_code"
                :class="{ 'p-invalid': $page.props.errors.referral_code }"
              />
              <div
                v-if="$page.props.errors.referral_code"
                class="error_information"
              >
                <i class="pi pi-arrow-up" />
                {{ $page.props.errors.referral_code }}
              </div>
            </div>
          </div>
          <hr class="w-11/12 mx-auto text-fh-gray-light" />
          <div class="flex flex-col my-10 justify-center items-center">
            <!-- <div>
              <div class="field-checkbox align-bottom">
                <span
                  ><Checkbox
                    id="terms"
                    v-model="form.terms"
                    :binary="true"
                    :class="{ 'p-invalid': $page.props.errors.terms }"
                /></span>
                <span>
                  <label class="text-sm align-bottom" for="terms"
                    >我已閱讀並同意此網站之「<Link :href="route('terms')"
                      >服務條款</Link
                    >」及「<Link :href="route('privacy')">隱私權政策</Link
                    >」。</label
                  ></span
                >
              </div>
              <div v-if="$page.props.errors.terms" class="error_information">
                <i class="pi pi-arrow-up" /> {{ $page.props.errors.terms }}
              </div>
            </div> -->
            <div class="text-center">
              <div
                v-if="$page.props.errors.name"
                class="error_information mb-4"
              >
                您填寫的資料有問題，請修改後再試一次。
              </div>

              <div class="my-1">
                <Button
                  :icon="term_accepted ? 'pi pi-check' : 'pi pi-search'"
                  :class="{ 'p-button-success' : term_accepted }"
                  :label="term_accepted ? '我已閱讀並且同意「網站使用條款」' : '閱讀「網站使用條款」'"
                  class="p-button-sm p-button-outlined"
                  @click="showAcceptModal('term')"
                />
              </div>
              <div class="my-1">
                <Button
                  :icon="privacy_accepted ? 'pi pi-check' : 'pi pi-search'"
                  :class="{ 'p-button-success' : privacy_accepted }"
                  :label="privacy_accepted ? '我已閱讀並且同意「網站隱私權條款」' : '閱讀「網站隱私權條款」'"
                  class="p-button-sm p-button-outlined"
                  @click="showAcceptModal('privacy')"
                />
              </div>
              <div class="my-1">
                <Button
                :icon="return_accepted ? 'pi pi-check' : 'pi pi-search'"
                  :class="{ 'p-button-success' : return_accepted }"
                  :label="return_accepted ? '我已閱讀並且同意「退換貨及退費規則」' : '閱讀「退換貨及退費規則」'"
                  class="p-button-sm p-button-outlined"
                  @click="showAcceptModal('return')"
                />
              </div>

              <div class="mt-5">
                <Button
                  :label="
                    term_accepted && privacy_accepted && return_accepted
                      ? '加入會員'
                      : '請先閱讀以上條款並按下「同意」'
                  "
                  :icon="
                    term_accepted && privacy_accepted && return_accepted
                      ? 'pi pi-check'
                      : 'pi pi-arrow-up'
                  "
                  iconPos="left"
                  @click="submit"
                  :disabled="
                    !term_accepted || !privacy_accepted || !return_accepted
                  "
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Layout from "@/Shared/Layout";
import Dropdown from "primevue/dropdown";
import InputText from "primevue/inputtext";
import Password from "primevue/password";
import Checkbox from "primevue/checkbox";
import Button from "primevue/button";
import Dialog from "primevue/dialog";

export default {
  layout: Layout,
  components: {
    Dropdown,
    InputText,
    // InputMask,
    Password,
    Checkbox,
    Button,
    Dialog,
  },
  watch: {
    timer: {
      handler(value) {
        if (this.sms.counting == true) {
          if (value > 0) {
            setTimeout(() => {
              this.timer--;
            }, 1000);
          } else {
            this.sms.counting = false;
          }
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      form: {
        name: "",
        mobile: "",
        email: "",
        password: "",
        password_confirmation: "",
        terms: "",
        referral_code: "",
        mobile_confirmation: "",
      },
      timer: 0,
      sms: {
        counting: false,
        verify: "",
        is_verifying: false,
        is_verified: false,
        is_failed: false,
      },
      term_accepted: false,
      privacy_accepted: false,
      return_accepted: false,
      showModal: false,
      modalType: null,
    };
  },
  computed: {
    used_referral_code() {
      let name = "referred_code";
      let match = document.cookie.match(
        new RegExp("(^| )" + name + "=([^;]+)")
      );
      if (match) return match[2];
      return null;
    },
  },
  methods: {
    showAcceptModal(type) {
      this.modalType = type;
      this.showModal = true;
    },
    acceptPolicy() {
      if (this.modalType == "term") {
        this.term_accepted = true;
      }

      if (this.modalType == "privacy") {
        this.privacy_accepted = true;
      }

      if (this.modalType == "return") {
        this.return_accepted = true;
      }

      this.showModal = false;
    },
    submit() {
      this.$inertia.post(route("register"), _.pickBy(this.form), {
        preserveScroll: true,
      });
    },
    checkSmsVerify() {
      this.sms.is_failed = false;
      if (this.form.mobile != this.form.mobile_confirmation) {
        this.sms.is_verifyed = false;
        this.sms.verify = "";
      } else {
        this.sms.is_verifyed = true;
      }
    },
    smsSend() {
      this.sms.counting = true;
      this.timer = 60;

      axios
        .post(route("sms.send_verification"), {
          mobile: this.form.mobile,
        })
        .then((response) => {
          if (response.data.successed == true) {
            this.$toast.add({
              severity: "success",
              summary: "手機驗證碼已發送",
              detail:
                "請將您收到的六位數字驗證碼輸入於驗證碼欄位完成手機驗證。",
              life: 3000,
            });
          } else {
            this.$toast.add({
              severity: "error",
              summary: "手機驗證碼發送失敗",
              detail:
                response.data.error +
                "如一直無法進行驗證，請與客服聯繫取得進一步的協助。",
              life: 10000,
            });
          }
        })
        .catch((error) => {
          this.$toast.add({
            severity: "error",
            summary: "無法發送手機驗證碼",
            detail:
              "請檢查您的網路連線後再試一次。如一直無法進行驗證，請與客服聯繫取得進一步的協助。",
            life: 10000,
          });
        });
    },
    smsVerify() {
      this.sms.is_failed = false;
      if (this.sms.verify.length >= 6) {
        this.sms.is_verifying = true;
        axios
          .post(route("sms.verify"), {
            mobile: this.form.mobile,
            code: this.sms.verify,
          })
          .then((response) => {
            if (response.data.mobile === this.form.mobile) {
              this.form.mobile_confirmation = response.data.mobile;
              this.sms.is_verifyed = true;
            } else {
              this.sms.is_failed = true;
              this.sms.verify = "";
              this.$toast.add({
                severity: "error",
                summary: "手機驗證碼錯誤",
                detail: "請檢查您所收到的手機驗證碼後再試一次。",
                life: 10000,
              });
            }
          })
          .finally(() => {
            this.sms.is_verifying = false;
          });
      }
    },
  },
  mounted() {
    if (this.used_referral_code != null)
      this.form.referral_code = this.used_referral_code;
  },
};
</script>

<style lang="postcss">
.card {
  @apply border border-solid border-fh-gray-light;
}

.tab {
  @apply border-solid border-fh-gray-light w-1/2 text-center p-4;
}

.register_form_element {
  @apply my-10 flex flex-col md:flex-row items-center text-center md:text-left;
}

.register_form_element .label {
  @apply text-center mb-2 md:mb-0 md:text-right w-1/3 md:mr-5 text-sm;
}

.register_form_element .input {
  @apply text-center md:text-left w-2/3;
}

.error_information {
  @apply text-red mt-1 pl-1;
}
</style>